// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormTask } from '~/utils/interface/task';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      title: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      accountId: yup.string().trim().optional(),
      dueDate: yup.string().trim().optional(),
      description: yup.string().trim().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormTask = {
  title: EMPTY_STRING,
  accountId: EMPTY_STRING,
  dueDate: EMPTY_STRING,
  description: EMPTY_STRING,
};
